import {Trans} from '@lingui/macro';
import React, {FC} from 'react';

import {AsyncStatusesEnum} from '../../../../libs/shared/helpers/src/types/asyncStatuses';
import {Skeleton} from '../../../components/common/skeleton';
import {ApiTokenModel} from '../../../models/api/apiTokenModel';
import {LocalApplicationModel} from '../../../models/api/localApplicationModel';
import {SettingsDevelopersPagesEnum, SettingsDevelopersUrl} from '../../../models/url/settingsUrlModel';
import {SettingsDevelopersHeaderFeatureTitleContainer} from './settingsDevelopersHeaderFeatureTitleContainer';

/*
 * Props.
 */

interface SettingsDevelopersHeaderTitleProps {
  url: SettingsDevelopersUrl;
  application?: LocalApplicationModel;
  token?: ApiTokenModel;
  isApplicationLoading: boolean;
  applicationAsyncStatus?: AsyncStatusesEnum;
  tokensAsyncStatus: AsyncStatusesEnum;
}

/*
 * Component.
 */

export const SettingsDevelopersHeaderTitle: FC<SettingsDevelopersHeaderTitleProps> = (props) => {
  const {url, application, token, applicationAsyncStatus, isApplicationLoading, tokensAsyncStatus} = props;
  const isViewingApplication =
    url.subPage !== SettingsDevelopersPagesEnum.APPLICATIONS &&
    url.subPage !== SettingsDevelopersPagesEnum.TOKENS;

  if (isViewingApplication) {
    if (isApplicationLoading) {
      return <Skeleton width="200px" height="28px" />;
    }
    if (applicationAsyncStatus === AsyncStatusesEnum.FAILED) {
      return <Trans id="settings-developers-title-app-failed">Error loading app</Trans>;
    }
    if (url.subPage === SettingsDevelopersPagesEnum.APPLICATION_FEATURES && url.feature) {
      return (
        <SettingsDevelopersHeaderFeatureTitleContainer
          feature={url.feature}
          applicationId={url.applicationId}
        />
      );
    }
    if (url.subPage === SettingsDevelopersPagesEnum.APPLICATION_SERVERS && url.isConnecting) {
      return <Trans id="settings-developers-title-connect-server">Connect server</Trans>;
    }
    if (url.subPage === SettingsDevelopersPagesEnum.APPLICATION_SERVERS && url.serverId) {
      return <Trans id="settings-developers-title-edit-server">Edit server</Trans>;
    }
    return (
      <>{application?.name ?? <Trans id="settings-developers-title-app-not-found">App not found</Trans>}</>
    );
  }

  if (url.subPage === SettingsDevelopersPagesEnum.TOKENS && url.tokenId) {
    if (tokensAsyncStatus === AsyncStatusesEnum.LOADING) {
      return <Skeleton width="200px" height="28px" />;
    }
    if (tokensAsyncStatus === AsyncStatusesEnum.FAILED) {
      return <Trans id="settings-developers-title-token-erred">Error loading tokens</Trans>;
    }
    return (
      <>
        {token?.name ?? token?.publicId ?? (
          <Trans id="settings-developers-title-token-not-found">API Token not found</Trans>
        )}
      </>
    );
  }

  return <Trans id="settings-developers-title">Developers</Trans>;
};
